module.exports = __webpack_public_path__ + "static/media/megaphone-b.87e6d4b2.svg";